export const API_URL_BANK_ID_AUTHORIZE2 = "/shop/api/bankid/authorize2";
export const API_URL_BANK_ID_AVAILABLE = "/shop/api/bankid/available";
export const API_URL_BANK_ID_DSF_MISMATCH = "/shop/api/bankid/dsf";
